import { HardLoadingItem } from '@/components/hard-loading/hard-loading'
import Store from '../store/index'

export function addLoadingItem(loadingItem: HardLoadingItem) {
  Store.dispatch('hardLoading/addLoadingItem', loadingItem)
}
export function removeLoadingItem(itemId: string) {
  Store.dispatch('hardLoading/removeLoadingItem', itemId)
}
export function updateLoadingItem(loadingItem: HardLoadingItem) {
  Store.dispatch('hardLoading/updateLoadingItem', loadingItem)
}

export function getLoadingItem(id: string) {
  return Store.getters['hardLoading/getById'](id)
}